<abc-popup #abcPopup [width]="'60%'" [height]="'50%'" [resizeEnabled]="true" [title]="this.res.get('Object-Sets')">
  <abc-button
    class="openOrderUnitPopup objectSetsBtn"
    [icon]="'add'"
    [disabled]="isReadOnly"
    (onClick)="openOrderUnitPopup()"
    [toolTipContent]="this.res.get('Create-New-Object-Sets')"
  ></abc-button>
  <abc-button
    class="saveDataEntities objectSetsBtn"
    [icon]="'save'"
    [disabled]="!canSave"
    (onClick)="openSaveOrOverwritePopup()"
    [toolTipContent]="this.res.get('Overwrite-Or-Add-New-Objects')"
  ></abc-button>
  <abc-button
    #filterBySelectedObjectSetsButton
    class="filterBySelectedObjectSets objectSetsBtn"
    [icon]="this.res.svgUrl('Objects-Sets-Filter')"
    [toolTipContent]="this.res.get('Filter-By-Selected-Object-Sets')"
    (onClick)="filterBySelectedObjectSet()"
    [disabled]="true"
  ></abc-button>
  <abc-button
    class="orderUnitTypeColumn objectSetsBtn"
    [icon]="'filter'"
    (onClick)="toggleOrderUnitTypeColumn()"
    [toolTipContent]="this.res.get('Activate-Order-Unit')"
  ></abc-button>
  <abc-grid
    class="abcGridSelections"
    #objectSetsGrid
    [setupDefaultLayoutOnInitialization]="true"
    [height]="'90%'"
    [dataSource]="this.objectsSetsStore"
    [focusedRowEnabled]="true"
    [autoNavigateToFocusedRow]="false"
    [columns]="this.columns"
    (onRowUpdating)="onRowUpdating($event)"
    (onRowRemoving)="onRowRemoving($event)"
    [selection]="{ mode: 'single' }"
    (onFocusedRowChanged)="onFocusedRowChanged($event)"
    [loadPanel]="{ enabled: true, visible: isRowDeleted }"
  >
    <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>
    <dxo-paging [pageSize]="20"></dxo-paging>
    <dxo-editing
      [useIcons]="true"
      [allowUpdating]="!isReadOnly"
      [allowDeleting]="!isReadOnly"
      [allowAdding]="false"
      [confirmDelete]="false"
    >
    </dxo-editing>
    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

    <div *dxTemplate="let objectsSet of 'detail'">
      <object-selection-items [objectsSet]="objectsSet.data"></object-selection-items>
    </div>
  </abc-grid>
</abc-popup>

<abc-popup
  #orderUnitPopup
  [width]="'450px'"
  [height]="'230px'"
  [title]="this.res.get('Create-New-Object-Set', (this.sourceDataEntities().entities?.length ?? 0).toString())"
>
  <p class="orderUnit">{{ this.res.get('Select-Order-Unit-Message') }}</p>
  <abc-select-box
    #orderUnitTypeSelectBox
    class="orderUnit"
    [label]="this.res.get('Order-Unit-Type')"
    [dataSource]="this.orderUnitDataSource"
    [displayExpr]="'caption'"
    [valueExpr]="'referencedObjectTypeValue'"
    (onItemClick)="onOrderUnitTypeValueChange($event)"
    [(value)]="referencedObject.objectType"
  ></abc-select-box>
  <abc-select-box
    #orderUnitSelectBox
    class="orderUnit"
    [label]="this.res.get('Order-Unit-Designation')"
    [(dataSource)]="this.selectedOrderUnitData"
    [displayExpr]="'Designation'"
    [valueExpr]="'Id'"
    (onItemClick)="onOrderUnitValueChange($event)"
    [(value)]="referencedObject.id"
  ></abc-select-box>

  <abc-button
    class="button-ok"
    [text]="this.res.get('Ok')"
    (onClick)="saveSourceDataEntitesWithOrderUnit()"
  ></abc-button>
  <abc-button class="button-cancel" [text]="this.res.get('Cancel')" (onClick)="closeOrderUnitPopup()"></abc-button>
</abc-popup>

<abc-popup
  #addOrOverwritePopup
  [width]="'510px'"
  [height]="'210px'"
  [title]="this.res.get('AddOrOverwriteObject-Title', (this.sourceDataEntities().entities?.length ?? 0).toString())"
>
  <p class="addOrOverwrite">{{ this.res.get('AddOrOverwriteObject-Message') }}</p>
  <abc-radio-group
    #addOrOverwriteRadioGroup
    class="addOrOverwriteRadioGroup"
    [items]="addOrOverwriteChoices"
    [value]="addOrOverwriteChoices[0]?.value"
    [valueExpr]="'value'"
    [displayExpr]="'caption'"
  >
  </abc-radio-group>

  <abc-button class="button-ok" [text]="this.res.get('Ok')" (onClick)="saveOrOverwriteObjectSet()"></abc-button>
  <abc-button class="button-cancel" [text]="this.res.get('Cancel')" (onClick)="closeAddOrOverwritePopup()"></abc-button>
</abc-popup>
